(function () {

    let skus = ['P02723-B21', 'P02722-B21', 'P03632-B21', 'P06453-B21', 'P06454-B21', 'P06455-B21', 'P02466-B21', 'P02465-B21', 'P02464-B21', 'P06423-B21', 'P06422-B21', 'P06421-B21']
    let SelectorsDictionary = {
        //New Radio ID starts with new
        NewRadio: 'input[type="radio"][name="cpo-condition-pdp"][id^="new"]',
        PreOwnedRadio: 'input[type="radio"][name="cpo-condition-pdp"][id^="cpo"]',
    }

    function isPdpOnListOfSkus() {
        let sku = window.location.pathname.split('/').pop().split('?')[0];
        sku=sku.toUpperCase();
        window['feHPEB2C'].log('FE: 4027: isPdpOnListOfSkus() sku=' + sku);
        return skus.indexOf(sku) > -1;
    }

    function init() {
        window['feHPEB2C'].log('FE: 4027: init()');
        if (!isPdpOnListOfSkus()) return;

        window['feHPEB2C'].log('FE: 4027: isPdpOnListOfSkus()==true');
        //select PreOwnedRadio radio button
        jQuery(SelectorsDictionary.PreOwnedRadio).click();
        //hide label for NewRadio
        jQuery(SelectorsDictionary.NewRadio).closest('label').hide();
        //hide radio button for PreOwnedRadio
        jQuery(SelectorsDictionary.PreOwnedRadio).hide();
    }

    window.feUtils.waitForConditions({
        conditions: [SelectorsDictionary.NewRadio],
        activity: feProjectId,
        callback: init,
    })
    window['feHPEB2C'].log('FE: 4027: end of v1.js');
})();
